import url from "url/index";
import { api } from "utils/hostname";

export interface SportsBookJWTResponse {
  token: string;
}
export const fetchSportsBookJWT = async (): Promise<SportsBookJWTResponse> => {
  try {
    const response = await api(true, true, "v2").get<SportsBookJWTResponse>(
      url.config.api.games.sportsBook,
    );
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch JWT");
  }
};
